export const CEMETERY_ID = 'd8bd1f88-cdde-4ef2-a448-5ab04d2d8107'

// Old Baptist Cemetery, Coram NY — second cemetery
export const OBC_CEMETERY_ID       = '8c4b3a2e-9d1f-4a76-b8e5-2c3d4e5f6a7b'
export const OBC_CARTER_SOURCE_ID  = '9d5c4b3f-0e2a-4b87-c9f6-3d4e5f6a7b8c'

export const SOURCE_IDS = {
  CHURCH:               '800c5884-d180-42b0-9ca6-4e05c8fd64cb',
  MALLMANN:             '9cb5c6d4-83b2-4ec6-ae59-72d2d7eb1155',
  WHITE_TILLOTSON_2008: 'a3b4c5d6-e7f8-4901-bcde-f01234567890',
  WHITE_TILLOTSON_2001: 'e5f6a7b8-c9d0-4e01-efab-c01234567890',
  WHITE_MILLER_2007:    'f6a7b8c9-d0e1-4f01-abcd-ef1234567890',
  // Alias kept for any code still referencing SOURCE_IDS.WHITE
  WHITE:                'a3b4c5d6-e7f8-4901-bcde-f01234567890',
}

export const ROLES = {
  ADMIN:      'admin',
  RESEARCHER: 'researcher',
  VOLUNTEER:  'volunteer',
}

export const REL_LABEL = {
  spouse:  'Spouse of',
  parent:  'Parent of',
  child:   'Child of',
  sibling: 'Sibling of',
  unknown: 'Related to',
}

export const INVERSE_REL = {
  spouse:  'spouse',
  parent:  'child',
  child:   'parent',
  sibling: 'sibling',
  unknown: 'unknown',
}

// AI-extraction relationship labels, used by import tools that parse
// AI-extracted genealogy text (PARENT_OF / CHILD_OF / SPOUSE / SIBLING_OF),
// translated to this app's native kinship.relationship_type values
// (parent / child / spouse / sibling).
//
// Convention: "person_a RELATIONSHIP person_b" (e.g. CHILD_OF means a is the
// child of b). kinship convention: (primary, relative, type) = "relative IS
// type TO primary". So:
//   PARENT_OF(a,b) -> (a,b,'child') + (b,a,'parent')
//   CHILD_OF(a,b)  -> (a,b,'parent') + (b,a,'child')
//
// Added 2026-10-22 after a code-review found three import tools
// (MallmannImport.jsx, WhiteImport.jsx, OldBaptistImport.jsx) each carrying
// their own naive, backward translation (see docs/data-quality/
// kinship-import-pipeline-findings-2026-10-22.md). ChurchImport.jsx already
// had the correct mapping inline; this centralizes it so a future importer
// can't reintroduce the same bug.
export const AI_REL_TO_DB = {
  PARENT_OF:  'child',
  CHILD_OF:   'parent',
  SPOUSE:     'spouse',
  SIBLING_OF: 'sibling',
}

export const AI_REL_TO_DB_INVERSE = {
  PARENT_OF:  'parent',
  CHILD_OF:   'child',
  SPOUSE:     'spouse',
  SIBLING_OF: 'sibling',
}
